/* eslint-disable no-multi-spaces */
/* eslint-disable key-spacing */
import isFinite from 'lodash/isFinite'
import { useContext } from 'react'

import { LiabilitiesContext } from '../../context'
import { parseNumber } from '@utils/numberConversions'

export const buildInitialValues = () => {
  const { state } = useContext(LiabilitiesContext)
  const { liability, formLiabilityType } = state
  const initialValues = {
    name:                liability.name || '',
    value:               isFinite(liability.value) ? liability.value : null,
    monthly_repayment:   isFinite(liability.monthly_repayment) ? liability.monthly_repayment : null,
    interest_rate:       getLiabilityInterestRate(liability) || 0,
    term_of_debt:        liability.term_of_debt || 0,
    liability_type:      formLiabilityType
  }
  return initialValues
}

const getLiabilityInterestRate = (liability) => {
  const liabilityInterestRate = liability.interest_rate && parseNumber(liability.interest_rate).toFixed(2)

  return liabilityInterestRate
}

export const getLabel = (name) => {
  const labels = {
    name:                'Give the liability a name',
    value:               'Outstanding balance',
    monthly_repayment:   'Total monthly repayment',
    interest_rate:       'Annual interest rate %',
    term_of_debt:        'How long will it take to pay the debt back? (Years)'
  }
  return labels[name]
}
